import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const generationDetailStyle = {
  display: "flex",
  gap: "10px",
  alignItems: "center",
};

const GenerationDetails = ({ generation }) => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1080);

  // Update screen size state on resize
  React.useEffect(() => {
    const handleResize = () => setIsLargeScreen(window.innerWidth >= 1080);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /*
   * Function to download all images as a zip
   */
  const downloadAllImages = async () => {
    const zip = new JSZip();
    const folder = zip.folder(`ambaram_${generation._id}`);

    // Fetch each image and add it to the zip folder
    await Promise.all(
      generation.ambaramImages.map(async (image, index) => {
        const response = await fetch(image.url);
        const blob = await response.blob();
        folder.file(`image${index + 1}.jpg`, blob); // Add image with index-based naming
      })
    );

    // Generate and download the zip file
    zip.generateAsync({ type: "blob" }).then((blob) => {
      saveAs(blob, `ambaram${generation._id}.zip`);
    });
  };

  const copySeed = () => {
    navigator.clipboard
      .writeText(generation.seed)
      .then(() => {
        console.log(`Copied to clipboard: ${generation.seed}`);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  return (
    <div>
      {isLargeScreen ? (
        <div style={generationDetailStyle}>
          <p>
            Model: <b>{generation.modelName}</b>
          </p>
          <p>
            Style: <b>{generation.presetStyle}</b>
          </p>
          <p>
            Dimensions:{" "}
            <b>
              {generation.imageWidth || 1024}x{generation.imageHeight || 768}
            </b>
          </p>
          <Dropdown>
            <Dropdown.Toggle variant="primary" id="dropdown-more">
              {" "}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => downloadAllImages()}>
                Download All
              </Dropdown.Item>
              <Dropdown.Item onClick={() => copySeed()}>
                Copy Seed
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ) : (
        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-more">
            ...
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item>
              Model: <b>{generation.modelName}</b>
            </Dropdown.Item>
            <Dropdown.Item>
              Preset: <b>{generation.presetStyle}</b>
            </Dropdown.Item>
            <Dropdown.Item>
              Dimensions:{" "}
              <b>
                {generation.imageWidth || 1024}x{generation.imageHeight || 768}
              </b>
            </Dropdown.Item>
            <Dropdown.Divider />
            <Dropdown.Item onClick={() => downloadAllImages()}>
              Download All
            </Dropdown.Item>
            <Dropdown.Item onClick={() => copySeed()}>Copy Seed</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
};

export default GenerationDetails;
